import { OktonPlatformProvider } from '@okton/platform-ui';
import React, { ReactNode, useMemo } from 'react';

import { AuthProvider, useAuth } from './auth';
import { integraSystem, platformClient } from '../services/platform';

interface IAppProvider {
  children: ReactNode;
}

const IntegraPlatformProvider: React.FC<IAppProvider> = ({ children }) => {
  const { user } = useAuth();

  const platformUser = useMemo(
    () =>
      user
        ? {
            id: user.id,
            name: user.name || user.email,
            email: user.email,
            avatarUrl: user.avatarUrl,
          }
        : undefined,
    [user],
  );

  const businessContext = useMemo(
    () =>
      user?.empresa_id || user?.filial_id
        ? {
            companyId: user.empresa_id,
            branchId: user.filial_id,
          }
        : undefined,
    [user],
  );

  return (
    <OktonPlatformProvider
      system={integraSystem}
      user={platformUser}
      businessContext={businessContext}
      features={{
        profile: true,
        billing: false,
        branchSwitching: false,
        notifications: false,
      }}
      client={user ? platformClient : undefined}
    >
      {children}
    </OktonPlatformProvider>
  );
};

const AppProvider: React.FC<IAppProvider> = ({ children }: IAppProvider) => (
  <AuthProvider>
    <IntegraPlatformProvider>{children}</IntegraPlatformProvider>
  </AuthProvider>
);

export default AppProvider;
